import PeopleIcon from '@mui/icons-material/People';
import SecurityIcon from '@mui/icons-material/Security';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Box, Button, Card, List, ListItem, styled } from '@mui/material';
import { useContext } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import { PermissionsGuard } from '../../../../content/routes';
import { SidebarContext } from '../../../../contexts';

const StyledSubMenu = styled(Card)(
  ({ theme }) => `
  position: absolute;
  top: 160px;
  left: 80px;
  width: 250px;
  background-color: ${theme.colors.secondary.light};

  & .MuiButtonBase-root {
    color: ${theme.colors.alpha.white[100]}; 
    width: 100%;
    justify-content: left;

    &:hover {
      color: ${theme.colors.primary.main}
    }
  }
  `
);

export function CollapsedUsersSubMenu() {
  const { closeSidebar, changeUsersSubMenuToggle } = useContext(SidebarContext);

  return (
    <>
      <Box
        onClick={() => changeUsersSubMenuToggle()}
        sx={{
          position: 'absolute',
          zIndex: 7,
          width: '100%',
          height: '100%'
        }}
      >
        <StyledSubMenu>
          <List component="div">
            <PermissionsGuard allowedPermissions={['viewAllUsers', 'viewClientUsers']}>
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/users/list"
                  startIcon={<PeopleIcon />}
                >
                  List
                </Button>
              </ListItem>
            </PermissionsGuard>
            <PermissionsGuard allowedPermissions={['viewUserRole']}>
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/users/roles"
                  startIcon={<SecurityIcon />}
                >
                  Roles
                </Button>
              </ListItem>
            </PermissionsGuard>
            <PermissionsGuard allowedPermissions={['viewUserPermission']}>
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/users/permissions"
                  startIcon={<VerifiedUserIcon />}
                >
                  Permissions
                </Button>
              </ListItem>
            </PermissionsGuard>
          </List>
        </StyledSubMenu>
      </Box>
    </>
  );
}
